import AuthCMS from "../../Layouts/AuthCMS"

const AppList = () => {
    return (
        <AuthCMS tabActive={"/terms"}>
            <div className="nt-theme-content nt-clearfix content-container bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold text-gray-800 mb-4">BasicProxy – Thỏa Thuận Sử Dụng Dịch Vụ</h3>
                <p className="text-gray-700 mb-4">
                    BasicProxy (“Chúng tôi”) xin gửi đến quý khách hàng (“Bạn”, “Người dùng” hoặc “Người đăng ký”) những điều khoản thỏa thuận sử dụng dịch vụ. Việc sử dụng dịch vụ của BasicProxy đồng nghĩa với việc chấp thuận những điều khoản thỏa thuận rõ ràng trong văn bản này (“Điều khoản sử dụng dịch vụ”) và các điều khoản bổ sung cho từng dịch vụ cụ thể.
                </p>
                <hr className="border-t border-gray-300 my-6" />
                <h3 className="text-xl font-semibold text-gray-800 mb-4">1. Quy định từ chối phục vụ</h3>
                <p className="text-gray-700 mb-4">
                    BasicProxy có quyền tạm dừng hoặc từ chối cung cấp dịch vụ, bao gồm việc khóa tài khoản mà không hoàn tiền, nếu khách hàng vi phạm một trong các quy định sau:
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">1.1. Hành vi vi phạm pháp luật</h4>
                <p className="text-gray-700 mb-4">
                    Khách hàng sử dụng dịch vụ để thực hiện các hành vi trái pháp luật, bao gồm nhưng không giới hạn:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4">
                    <li>Phá hoại an ninh quốc gia, trái với luật pháp Việt Nam hoặc các quy định quốc tế.</li>
                    <li>Truyền bá nội dung chống phá nhà nước, xung đột tôn giáo/chính trị, hoặc vi phạm thuần phong mỹ tục.</li>
                </ul>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">1.2. Sử dụng tài nguyên không phù hợp</h4>
                <ul className="list-disc list-inside text-gray-700 mb-4">
                    <li>Phát tán thư rác (SPAM), thư quảng cáo không mong muốn.</li>
                    <li>Phát tán mã độc, tấn công DDOS, hoặc các hoạt động gây hại khác.</li>
                    <li>Sử dụng dịch vụ cho các mục đích trái phép như khai thác tiền điện tử (Coin Mining).</li>
                </ul>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">1.3. Vi phạm bản quyền và danh dự uy tín</h4>
                <ul className="list-disc list-inside text-gray-700 mb-4">
                    <li>Mạo danh tổ chức hoặc cá nhân.</li>
                    <li>Phát tán nội dung giả mạo hoặc vi phạm bản quyền.</li>
                </ul>
                <hr className="border-t border-gray-300 my-6" />
                <h3 className="text-xl font-semibold text-gray-800 mb-4">2. Trách nhiệm của khách hàng</h3>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">2.1. Bảo mật tài khoản</h4>
                <p className="text-gray-700 mb-4">
                    Khách hàng có trách nhiệm bảo quản thông tin đăng nhập và thông báo ngay cho BasicProxy nếu phát hiện hành vi truy cập trái phép.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">2.2. Tuân thủ pháp luật</h4>
                <p className="text-gray-700 mb-4">
                    Khách hàng tự chịu trách nhiệm trước pháp luật nếu vi phạm quy định và chấp nhận mọi hình thức xử lý từ cơ quan chức năng.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">2.3. Cung cấp thông tin chính xác</h4>
                <p className="text-gray-700 mb-4">
                    Mọi thông tin cung cấp khi đăng ký dịch vụ cần được đảm bảo tính chính xác.
                </p>
                <hr className="border-t border-gray-300 my-6" />
                <h3 className="text-xl font-semibold text-gray-800 mb-4">3. Trách nhiệm của BasicProxy</h3>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">3.1. Cung cấp dịch vụ đúng cam kết</h4>
                <p className="text-gray-700 mb-4">
                    BasicProxy bảo đảm dịch vụ đáp ứng các tiêu chuẩn được nêu trên trang chủ.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">3.2. Hỗ trợ khách hàng</h4>
                <p className="text-gray-700 mb-4">
                    Chúng tôi cung cấp hỗ trợ 24/7 và thông báo rõ ràng khi bảo trì dịch vụ.
                </p>
                <hr className="border-t border-gray-300 my-6" />
                <h3 className="text-xl font-semibold text-gray-800 mb-4">4. Tạm ngưng dịch vụ</h3>
                <p className="text-gray-700 mb-4">
                    Dịch vụ có thể bị tạm ngưng trong các trường hợp sau:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-4">
                    <li>Hết hạn thanh toán.</li>
                    <li>Vi phạm chính sách.</li>
                    <li>Có tranh chấp hoặc yêu cầu từ cơ quan pháp luật.</li>
                </ul>
                <hr className="border-t border-gray-300 my-6" />
                <h3 className="text-xl font-semibold text-gray-800 mb-4">5. Thông tin hóa đơn và thanh toán</h3>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">5.1. Hình thức thanh toán</h4>
                <p className="text-gray-700 mb-4">
                    Chúng tôi chỉ hỗ trợ thanh toán qua tài khoản ngân hàng được công khai trên hệ thống.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">5.2. Thanh toán trả trước</h4>
                <p className="text-gray-700 mb-4">
                    Mọi giao dịch đều yêu cầu thanh toán trước để duy trì dịch vụ.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">5.3. Thuế</h4>
                <p className="text-gray-700 mb-4">
                    Giá dịch vụ chưa bao gồm thuế VAT; khách hàng có trách nhiệm chi trả.
                </p>
                <h4 className="text-lg font-semibold text-gray-800 mb-4">5.4. Hoàn tiền</h4>
                <p className="text-gray-700 mb-4">
                    Hiện tại, BasicProxy không hỗ trợ hoàn tiền trong mọi trường hợp trừ khi bất khả kháng.
                </p>
                <hr className="border-t border-gray-300 my-6" />
                <h3 className="text-xl font-semibold text-gray-800 mb-4">6. Hỗ trợ</h3>
                <p className="text-gray-700 mb-4">
                    BasicProxy cung cấp đội ngũ hỗ trợ 24/7 qua các kênh liên hệ công khai.
                </p>
            </div>
        </AuthCMS>
    )
}

export default AppList